"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _articleManage = require("@/api/_homeCloudPlatform/article/articleManage.js");
var _commodityManage = require("@/api/_homeCloudPlatform/mall/commodityManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var formModel = {
  patient_gender: 0,
  label: []
};

// const phoneValidator = (rule, value, callBack) => {
//   const reg = /^[1][0-9]{10}$/
//   if (value) {
//     if (!reg.test(value)) {
//       callBack('请输入正确的联络人手机号')
//     } else {
//       callBack()
//     }
//   } else {
//     callBack()
//   }
// }
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  computed: {
    rules: function rules() {
      return {
        // contact_phone: [
        //   { required: true, message: '请输入联络人手机号', trigger: 'blur' },
        //   { validator: phoneValidator },
        //   { max: 11, message: '输入长度不能超过11位' }
        //   { type: 'number', message: '排序必须为数字值' }
        // ],
        case_number: [{
          required: true,
          message: '请输入病案号',
          trigger: 'blur'
        }, {
          max: 12,
          message: '输入长度不能超过12位'
        }],
        patient_name: [{
          required: true,
          message: '请输入患者姓名',
          trigger: 'blur'
        }, {
          max: 24,
          message: '输入长度不能超过24位'
        }],
        patient_ethnicity: [{
          required: true,
          message: '请输入患者民族',
          trigger: 'blur'
        }, {
          max: 24,
          message: '输入长度不能超过24位'
        }],
        age: [{
          required: true,
          message: '请输入年龄',
          trigger: 'blur'
        }, {
          max: 3,
          message: '输入长度不能超过3位'
        }],
        patient_hometown: [{
          required: true,
          message: '请输入患者籍贯',
          trigger: 'blur'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        hospital: [{
          required: true,
          message: '请输入就诊医院',
          trigger: 'blur'
        }, {
          max: 60,
          message: '输入长度不能超过60位'
        }],
        department: [{
          required: true,
          message: '请输入就诊科室',
          trigger: 'blur'
        }, {
          max: 60,
          message: '输入长度不能超过60位'
        }],
        attending_physician: [{
          required: true,
          message: '请输入主治医师',
          trigger: 'blur'
        }, {
          max: 30,
          message: '输入长度不能超过30位'
        }],
        chinese_diagnosis: [{
          required: true,
          message: '请输入中医诊断',
          trigger: 'blur'
        }, {
          max: 60,
          message: '输入长度不能超过60位'
        }],
        western_diagnosis: [{
          required: true,
          message: '请输入西医诊断',
          trigger: 'blur'
        }, {
          max: 60,
          message: '输入长度不能超过60位'
        }],
        chief_complaint: [{
          required: true,
          message: '请输入主诉',
          trigger: 'blur'
        }, {
          max: 90,
          message: '输入长度不能超过90位'
        }],
        present_illness_history: [{
          required: true,
          message: '请输入现病史',
          trigger: 'blur'
        }],
        past_medical_history: [{
          required: true,
          message: '请输入既往史',
          trigger: 'blur'
        }],
        allergy_history: [{
          required: true,
          message: '请输入过敏史',
          trigger: 'blur'
        }],
        physical_examination: [{
          required: true,
          message: '请输入体格检查',
          trigger: 'blur'
        }],
        laboratory_examination: [{
          required: true,
          message: '请输入实验室检查',
          trigger: 'blur'
        }],
        tts_treatment: [{
          required: true,
          message: '请输入新汉方TTS调理',
          trigger: 'blur'
        }],
        treatment_summary: [{
          required: true,
          message: '请输入调理总结',
          trigger: 'blur'
        }],
        case_analysis: [{
          required: true,
          message: '请输入病例分析',
          trigger: 'blur'
        }],
        sorting: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callBack) {
            // -10000 ~ 10000
            if (value * 1 > 9999) {
              callBack('输入的数字不应大于9999');
            } else {
              callBack();
            }
          }
        }]
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '检视';
          break;
        case 'add':
          type = '新增';
          break;
        case 'edit':
          type = '编辑';
          break;
      }
      return "".concat(type, "\u75C5\u4F8B\u5206\u4EAB");
    }
  },
  watch: {
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    }
  },
  data: function data() {
    return {
      formModel: formModel,
      disabled: false,
      tableData: {},
      listLoading: true,
      // 预设排序,依发布时间递减
      defaultOrdering: '-publication_date',
      listQuery: {
        page: 1,
        page_size: 20,
        page_size_before: 20
      },
      dialogVisible: false,
      dialogType: 'view',
      // 性别
      sexOptions: [{
        key: 1,
        display_name: '男'
      }, {
        key: 2,
        display_name: '女'
      }, {
        key: 0,
        display_name: '未知'
      }],
      // 状态选项
      statusOptions: [{
        key: 'all',
        display_name: '全部',
        value: 'all'
      }, {
        key: 'true',
        display_name: '上架',
        value: true
      }, {
        key: 'false',
        display_name: '下架',
        value: !true
      }],
      tagsList: [],
      // 链结商品
      linkedProductsOptions: []
    };
  },
  created: function created() {
    this.handleSort();
    this.getTagsList();
    this.getGoodsList();
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList(e) {
      var _this = this;
      this.listLoading = true;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      (0, _articleManage.getCaseSharingList)(this.handleQuery()).then(function (res) {
        _this.tableData = res || {};
        _this.listLoading = false;
      });
    },
    // 标籤清单
    getTagsList: function getTagsList() {
      var _this2 = this;
      (0, _commodityManage.getTagsList)().then(function (res) {
        _this2.tagsList = res.results.filter(function (item) {
          return item.type === 0;
        }) || [];
        _this2.tagsList.unshift({
          name: '全部',
          id: ''
        });
      });
    },
    getGoodsList: function () {
      var _getGoodsList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this3 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _commodityManage.getGoodsList)({
                page: 1,
                page_size: 1
              }).then(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(data) {
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (data.count) {
                          _context.next = 2;
                          break;
                        }
                        return _context.abrupt("return");
                      case 2:
                        _context.next = 4;
                        return (0, _commodityManage.getGoodsList)({
                          product_status: 1
                        }).then(function (res) {
                          _this3.linkedProductsOptions = res.results;
                        });
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getGoodsList() {
        return _getGoodsList2.apply(this, arguments);
      }
      return getGoodsList;
    }(),
    handleAdd: function handleAdd() {
      var _this4 = this;
      this.formModel = JSON.parse(JSON.stringify(formModel));
      this.handleInitData();
      this.dialogType = 'add';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs['Form'].clearValidate();
      });
    },
    handleView: function handleView(scope) {
      var _this5 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row));
      this.handleInitData();
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this6 = this;
      this.formModel = JSON.parse(JSON.stringify(scope.row)); // copy obj
      this.handleInitData();
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this6.$refs['Form'].clearValidate();
      });
    },
    // 初始化资料处理
    handleInitData: function handleInitData() {
      // label
      this.$set(this.formModel, 'labels', []);
      if (this.formModel.labels.length) {
        var arr = [];
        this.formModel.labels.forEach(function (item) {
          arr.push(item.name);
        });
        this.formModel.labels = arr;
      }
      if (this.formModel.goods && this.formModel.goods.length > 0) {
        var arr2 = [];
        this.formModel.goods.forEach(function (item) {
          arr2.push(item.id);
        });
        this.formModel.goods = arr2;
      }
    },
    handleDelete: function handleDelete(scope) {
      var _this7 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return deleteProduct(scope.row.id);
            case 2:
              _this7.getList();
              _this7.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(form) {
        var _this8 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this8.dialogType === 'edit';
                  if (isEdit) {
                    (0, _articleManage.updateCaseSharingt)(_this8.formModel.id, _this8.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this8.errorHandle(res);
                      }
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else if (_this8.dialogType === 'add') {
                    (0, _articleManage.createCaseSharing)(_this8.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this8.errorHandle(res);
                      }
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function confirm(_x2) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handleFormData: function handleFormData() {
      var _this9 = this;
      var arr = [];
      this.formModel.labels.forEach(function (item) {
        arr.push({
          name: item
        });
      });
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.formModel), {}, {
        labels: arr,
        label: function () {
          return;
        }(),
        status: function () {
          if (_this9.dialogType === 'edit') return _this9.formModel.status;
          return;
        }()
      });
      return params;
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size,
        ordering: this.listQuery.ordering
      };
      this.getList();
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      if (query.label_id === '' || query.label_id === 'all') {
        query.label_id = function () {
          return;
        }();
      }
      return query;
    },
    handleSort: function handleSort(column) {
      // 初始化处理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    }
  }
};